<div class="flex items-center justify-between mb-2 md:mb-4">
  <div class="flex items-center gap-4">
    <div
      class="rounded-full h-6 w-6 md:h-12 md:w-12 circle-bg-gradient flex flex-col items-center justify-center shrink-0"
    >
      <h2 class="mb-0.5! max-md:text-sm text-white">
        {{ stepperIndex() + 1 }}
      </h2>
    </div>
    <h2 class="m-0">
      <ng-content></ng-content>
    </h2>
  </div>
  <div class="max-md:hidden">
    {{ stepperIndex() + 1 }} of {{ totalSteps() }}
  </div>
</div>
<hr class="md:mb-8" />
<div class="md:hidden mt-2 mb-6 text-xs">
  {{ stepperIndex() + 1 }} of {{ totalSteps() }}
</div>
